import React from "react";

const faq4 = () =>{
  return(
    <>
      <p>
        <i>din</i>BiZ är en återkommande analys – den 
        blir aldrig ”färdig” eftersom
      </p>
      <ul>
        <li> Omvärlden förändras </li>
        <li> Affärsförutsättningar förändras </li>
        <li> Avsikt, mål och krav förändras </li>
        <li> Företagets utbud förändras </li>
        <li> Verksamhetens omfång, kapacitet, utveckling – och mera – förändras </li>
      </ul>
      <p>
        Du justerar analysen tills du är nöjd med 
        resultatet – för denna gången.
      </p>
      <p>
        <i>din</i>BiZ visar hårda siffror. Blir resultatet – 
        efter seriöst BiZ:ande – omöjligt lågt, får du 
        tänka om affärsidén från grunden.
      </p>
      <p>
        För högre kvalitet på data/analysunderlag
        Se Flik: <u>Förberedelser</u>
      </p>
    
    </>
  );
}
export default faq4;